import { render, staticRenderFns } from "./ElectionResultsDialog.vue?vue&type=template&id=760b2d94&scoped=true"
import script from "./ElectionResultsDialog.vue?vue&type=script&lang=js"
export * from "./ElectionResultsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b2d94",
  null
  
)

export default component.exports